import { useSelector } from 'hooks/utils';
import { selectDefaultOrganizationId } from 'store/data/collaborators';

export function useDefaultOrganizationId() {
	return useSelector(state => selectDefaultOrganizationId(state.data.collaborators));
}
